// extracted by mini-css-extract-plugin
export default {"root":"Avatar_root__EXfY-","icon":"Avatar_icon__BpKCz","verified":"Avatar_verified__2nkkw","image":"Avatar_image__txssE","fill":"Avatar_fill__hos4O","badge":"Avatar_badge__iO4Qx"};